import React, { useEffect, useMemo, useState } from "react";
import stylesInputLabel from "../../styles/Atoms/InputLabel/label";

import {
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const InputTime = ({
  label,
  value = "",
  setValue = () => {},
  hdlOnChange = () => {},
  validate = () => "",
  errorText = "",
  disabled = false,
  color,
  width = "100%",
  minuteStep = 30, // 5,10,15,30,60
  startHour = 0,
  endHour = 23,
  fontSize = "14px",
}) => {
  const colorDefecto = color ?? "#708198";

  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    const error = validate(value);
    setValidationError(error || "");
  }, [value, validate]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: colorDefecto,
          },
        },
      }),
    [colorDefecto],
  );

  const timeOptions = useMemo(() => {
    const options = [];

    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minute = 0; minute < 60; minute += minuteStep) {
        const formattedHour = String(hour).padStart(2, "0");
        const formattedMinute = String(minute).padStart(2, "0");

        options.push(`${formattedHour}:${formattedMinute}`);
      }
    }

    return options;
  }, [minuteStep, startHour, endHour]);

  const handleChange = (event) => {
    const selectedValue = event.target.value;

    setValue(selectedValue);
    hdlOnChange(selectedValue);

    const error = validate(selectedValue);
    setValidationError(error || "");
  };

  return (
    <ThemeProvider theme={theme}>
      <FormControl
        fullWidth
        error={Boolean(validationError || errorText)}
        disabled={disabled}
        sx={{
          width,
        }}
      >
        {label && (
          <FormLabel
            sx={{
              ...stylesInputLabel.label,
              color: `${colorDefecto} !important`,
              fontWeight: 600,
              fontFamily: "Raleway, sans-serif",
              marginBottom: "10px",
            }}
          >
            {label}
          </FormLabel>
        )}

        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          size="small"
          sx={{
            borderRadius: "10px",
            backgroundColor: "#fff",

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#d0d7de",
            },

            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colorDefecto,
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: colorDefecto,
              borderWidth: "2px",
            },

            "& .MuiSelect-select": {
              fontFamily: "Raleway, sans-serif",
              fontSize,
              color: value ? "#2c3e50" : "#9aa5b1",
              padding: "10px 14px",
            },
          }}
        >
          <MenuItem disabled value="">
            Selecciona una hora
          </MenuItem>

          {timeOptions.map((time) => (
            <MenuItem
              key={time}
              value={time}
              sx={{
                fontFamily: "Raleway, sans-serif",
                fontSize,
              }}
            >
              {time}
            </MenuItem>
          ))}
        </Select>

        {(validationError || errorText) && (
          <FormHelperText
            sx={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "12px",
              marginTop: "5px",
            }}
          >
            {validationError || errorText}
          </FormHelperText>
        )}
      </FormControl>
    </ThemeProvider>
  );
};

export default InputTime;
